import { Control } from 'ol/control';

export class DrawControls extends Control {
  constructor(options?: {
    target?: string | HTMLElement | undefined,
    onCancelDraw?: () => void,
    onRollback?: () => void,
    onClear?: () => void
  }) {

    const rollbackButton = document.createElement('button');
    rollbackButton.type = 'button';
    rollbackButton.id = 'map_rollback_changes';
    rollbackButton.innerHTML = 'Cofnij';

    const rollBackSmall = document.createElement('small');
    rollBackSmall.innerHTML = '(Ctrl + Z)';
    rollbackButton.appendChild(rollBackSmall);

    const cancelDrawButton = document.createElement('button');
    cancelDrawButton.type = 'button';
    cancelDrawButton.id = 'map_cancel_draw';
    cancelDrawButton.innerHTML = 'Wyjdź z rysowania';

    const cancelDrawSmall = document.createElement('small');
    cancelDrawSmall.innerHTML = '(ESC)';
    cancelDrawButton.appendChild(cancelDrawSmall);

    const clearButton = document.createElement('button');
    clearButton.type = 'button';
    clearButton.id = 'map_clear_draw';
    clearButton.innerHTML = 'Wyczyść';

    const clearSmall = document.createElement('small');
    clearSmall.innerHTML = '(Ctrl + X)';
    clearButton.appendChild(clearSmall);

    const element = document.createElement('div');
    element.className = 'draw ol-unselectable ol-control';
    element.append(cancelDrawButton);
    element.appendChild(rollbackButton);
    element.appendChild(clearButton);

    super({
      element: element,
      target: options?.target
    });

    if (options?.onCancelDraw) {
      cancelDrawButton.addEventListener('click', options.onCancelDraw.bind(this), false);
    }

    if (options?.onRollback) {
      rollbackButton.addEventListener('click', options.onRollback.bind(this), false);
    }

    if (options?.onClear) {
      clearButton.addEventListener('click', options.onClear.bind(this), false);
    }
  }
}
